
import React, { useEffect, useState, useCallback } from 'react';
import verificareToken from '../VerificareToken';
import { Box, Alert, Tab, Tabs, CircularProgress, Grid, Button, IconButton, Tooltip, FormControlLabel, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import Stocare from './Stocare'; 
import DrepturiUtilizator from './drepturiUtilizator'; 

const DateCont = () => {

  
    const [value, setValue] = useState(0);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };  
  
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [importDosareDefault, setImportDosareDefault] = useState(false);
    const [numerotareAutomata, setNumerotareAutomata] = useState(false);
    const [standardeNumerotare, setStandardeNumerotare] = useState([]);
    const [editingIndex, setEditingIndex] = useState(-1);
    const [editValue, setEditValue] = useState('');
    const [loadingNumerotare, setLoadingNumerotare] = useState(false);  
    const { areDrept } = DrepturiUtilizator();

    const AccesLaToataAplicatia = 'AccesLaToataAplicatia';

  const [dateCont, setDateCont] = useState({});
  //reactualizez starea lui authChange - verific starea lui isLoggedIn sa vad daca mai e logat
  window.dispatchEvent(new Event('authChange'));
   useEffect(() => {
    window.dispatchEvent(new Event('authChange'));
  }, []); 
    const { token } = verificareToken();
  
    const fetchData = useCallback(async () => {
    try {
      const response = await fetch(`${window.API_URL}dateCont`, {
        method: 'GET', 
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      const {data} = await response.json();
      setDateCont(data);
      console.log('[Api] -> DateCont:', data);
    } catch (error) {
      console.error(error);
    }
  }, [token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
 
 
 // Obținere stare inițială pentru import dosare
 const fetchImportDosareDefault = useCallback(async () => {
  setLoading(true);
  setError(null);
  try {
    const response = await fetch(`${window.API_URL}getImportDosareAsociatePeUserDefault`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) throw new Error('Eroare la obținerea setării import dosare');
    const { data } = await response.json();
    setImportDosareDefault(data?.value === "1"); // Gestionăm string "1" sau "0"
    console.log('[Api] -> getImportDosareAsociatePeUserDefault:', data);
  } catch (error) {
    console.error('[Api] -> getImportDosareAsociatePeUserDefault error:', error);
    setError('Nu s-a putut încărca setarea import dosare.');
  } finally {
    setLoading(false);
  }
}, [token]);

// Actualizare stare import dosare
const updateImportDosareDefault = useCallback(async (newValue) => {
  setLoading(true);
  setError(null);
  try {
    const response = await fetch(`${window.API_URL}setImportDosareAsociatePeUserDefault?value=${newValue ? 1 : 0}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    if (!response.ok) throw new Error('Eroare la actualizarea setării import dosare');
    const result = await response.json();
    if (result.status === 200) {
      setImportDosareDefault(newValue);
      console.log('[Api] -> setImportDosareAsociatePeUserDefault: success');
    } else {
      throw new Error('Răspuns API invalid');
    }
  } catch (error) {
    console.error('[Api] -> setImportDosareAsociatePeUserDefault error:', error);
    setError('Nu s-a putut actualiza setarea import dosare.');
  } finally {
    setLoading(false);
  }
}, [token]);

// Handler pentru schimbarea switch-ului
const handleSwitchChange = (event) => {
  const newValue = event.target.checked;
  updateImportDosareDefault(newValue);
};

// Funcții pentru numerotare automată
const fetchNumerotareAutomata = async () => {
  setLoadingNumerotare(true);
  try {
    const response = await fetch(`${window.API_URL}getSetting?settingName=NumerotareAutomata`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    const { data } = await response.json();
    setNumerotareAutomata(data?.value === "1");
  } catch (error) {
    console.error('Error fetching numerotare automata:', error);
  } finally {
    setLoadingNumerotare(false);
  }
};

const updateNumerotareAutomata = async (newValue) => {
  setLoadingNumerotare(true);
  try {
    const response = await fetch(`${window.API_URL}setSetting?settingName=NumerotareAutomata&value=${newValue ? 1 : 0}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    if (response.ok) {
      setNumerotareAutomata(newValue);
    }
  } catch (error) {
    console.error('Error updating numerotare automata:', error);
  } finally {
    setLoadingNumerotare(false);
  }
};

const fetchStandardeNumerotare = async () => {
  try {
    const response = await fetch(`${window.API_URL}standardeNumerotare`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    const result = await response.json();
    // Handle both direct array and wrapped response
    const data = Array.isArray(result) ? result : (result.data || []);
    setStandardeNumerotare(data);
    console.log('Standarde numerotare:', data);
  } catch (error) {
    console.error('Error fetching standarde numerotare:', error);
    setStandardeNumerotare([]);
  }
};

const updateContor = async (valoare) => {
  try {
    const response = await fetch(`${window.API_URL}modificaContor?valoare=${valoare}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    if (response.ok) {
      fetchStandardeNumerotare();
      setEditingIndex(-1);
      setEditValue('');
    }
  } catch (error) {
    console.error('Error updating contor:', error);
  }
};

const handleNumerotareChange = (event) => {
  const newValue = event.target.checked;
  updateNumerotareAutomata(newValue);
};

const handleEditContor = (index, currentValue) => {
  setEditingIndex(index);
  setEditValue(currentValue.toString());
};

const handleSaveContor = () => {
  if (editValue && !isNaN(editValue)) {
    updateContor(editValue);
  }
};

const handleCancelEdit = () => {
  setEditingIndex(-1);
  setEditValue('');
};

useEffect(() => {
  fetchData();
  fetchImportDosareDefault();
}, [fetchData, fetchImportDosareDefault]);

useEffect(() => {
  if (value === 3 && areDrept(AccesLaToataAplicatia)) {
    fetchNumerotareAutomata();
    fetchStandardeNumerotare();
  }
}, [value, token]);

  
   return (
    <>
    <Box sx={{ display: 'flex', height: '100%' }}> 
          <Tabs
            orientation="vertical"
            variant="scrollable"  
            aria-label="Sintagme"
            value={value}
            onChange={handleChange}
            sx={{
              borderRight: 1,
              borderColor: 'divider', 
              top: '10px',  
            }}
            style={{minWidth:'200px', width:'100%', maxWidth:'200px'}}
          >  
          <Tab key={0}  label="General" value={0} />
          <Tab key={1}  label="Spațiu stocare" value={1} /> 
          {areDrept(AccesLaToataAplicatia) && (
            <Tab key={2}  label="Setări instanță" value={2} />  
          )}
          {areDrept(AccesLaToataAplicatia) && (
            <Tab key={3}  label="Numerotare automată" value={3} />  
          )}
          </Tabs>
              <TabPanel value={value} index={0}>
                <Box component="div">
                  <div className=" container card p-4 ">
                    <table className="table table-responsive table-striped table-condensed table-hover align-middle" cellSpacing="2" cellPadding="2">
              
                      <tbody>
                        <tr>
                          <td className="col-6 align-middle">Licență aplicație</td>
                          <td className="col-6 align-middle"><strong>{dateCont.status?.serialno}</strong></td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Denumire cont</td>
                          <td className="col-6 align-middle">{dateCont.status?.company}</td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Versiune aplicație</td>
                          <td className="col-6 align-middle"><strong>{dateCont.status?.appversion}</strong></td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Versiune baze de date</td>
                          <td className="col-6 align-middle"><strong>{dateCont.status?.dbversion}</strong></td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Total dosare</td>
                          <td className="col-6 align-middle">{dateCont.countAllDosare}</td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Dosare Active</td>
                          <td className="col-6 align-middle">{dateCont.countDosareActive}</td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Dosare Suspendate</td>
                          <td className="col-6 align-middle">{dateCont.countDosareSuspendate}</td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Dosare Redeschise</td>
                          <td className="col-6 align-middle">{dateCont.countDosareRedeschise}</td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Dosare Perimate</td>
                          <td className="col-6 align-middle">{dateCont.countDosarePerimate}</td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Dosare Finalizate</td>
                          <td className="col-6 align-middle">{dateCont.countDosareFinalizate}</td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Dosare sincronizate</td>
                          <td className="col-6 align-middle">{dateCont.countDosareSincronizate}</td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Acces monitorizare dosare</td>
                          <td className="col-6 align-middle"><strong>{dateCont.dateLicenta?.date?.mMonitDosare === '1' ? 'DA' : 'NU'}</strong></td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Dosare monitorizate / Maxim monitorizabile</td>
                          <td className="col-6 align-middle">{dateCont.countDosareMonitorizate} / <strong>{dateCont.dateLicenta?.date?.nrDosareMon}</strong></td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Acces monitorizare B.P.I.</td>
                          <td className="col-6 align-middle"><strong>{dateCont.dateLicenta?.date?.mBPI === '1' ? 'DA' : 'NU'}</strong></td>
                        </tr>
                        <tr>
                        <td className="col-6 align-middle">Firme monitorizate B.P.I. / Maxim monitorizabile</td>
                        <td className="col-6 align-middle">{dateCont.countFirmeMonitorizate} / <strong>{dateCont.dateLicenta?.date?.nrFirmeBPI}</strong></td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Acces Legislație / Jurisprudență / Practică judiciară</td>
                          <td className="col-6 align-middle"><strong>{dateCont.dateLicenta?.date?.mActeOficiale === '1' ? 'DA' : 'NU'}</strong> / <strong>{dateCont.dateLicenta?.date?.mJurisprudenta === '1' ? 'DA' : 'NU'}</strong> / <strong>{dateCont.dateLicenta?.date?.mPracticaJudiciara === '1' ? 'DA' : 'NU'}</strong></td>
                        </tr>
                        <tr>
                          <td className="col-6 align-middle">Alerte SMS</td>
                          <td className="col-6 align-middle"><strong>{dateCont.dateLicenta?.date?.mAlerteSMS === '1' ? 'DA' : 'NU'}</strong></td>
                        </tr>
                      </tbody>
                      </table>
                      
                      </div>
                  </Box>
              </TabPanel>
            <TabPanel value={value} index={1}>
              <Stocare />
           </TabPanel>
             
           {areDrept(AccesLaToataAplicatia) && (
          <TabPanel value={value} index={2}>
            <Box sx={{ p: 3 }}>
                {loading && <CircularProgress size={24} sx={{ mb: 2 }} />}
                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                <Alert severity="info" sx={{ mb: 2 }}>
                  Activarea acestei opțiuni va permite preluarea dosarelor cu accesoriu exclusiv în contul utilizatorului <strong>import.dosare</strong>. Ulterior, realocarea dosarelor către utilizatorii responsabili se va putea efectua direct din aplicație, din același cont.
                </Alert>

                <FormControlLabel
                  control={
                    <Switch
                      checked={importDosareDefault}
                      onChange={handleSwitchChange}
                      color="primary"
                      disabled={loading}
                      className='mb-3'
                    />
                  }
                  label="Import dosare asociate pe user"
                />
                
                {importDosareDefault ? (
                  <Alert severity="success" sx={{ mb: 2 }}>
                    Opțiunea este activă. Opțiunea este activă. Dosarele cu accesorii vor fi importate în contul <strong>import.dosare</strong>.
                  </Alert>
                ) : (
                  <Alert severity="warning" sx={{ mb: 2 }}>
                    Opțiunea este dezactivată. Dosarele cu accesorii vor fi importate automat la fiecare utilizator.
                  </Alert>
                )}

              </Box>
          </TabPanel>
        )} 

        {areDrept(AccesLaToataAplicatia) && (
          <TabPanel value={value} index={3}>
            <Box sx={{ p: 3 }}>
              {loadingNumerotare && <CircularProgress size={24} sx={{ mb: 2 }} />}
              
              <FormControlLabel
                control={
                  <Switch
                    checked={numerotareAutomata}
                    onChange={handleNumerotareChange}
                    color="primary"
                    disabled={loadingNumerotare}
                  />
                }
                label="Numerotare automată"
              />
              
              {numerotareAutomata && (
                <Alert severity="info" sx={{ mt: 2, mb: 2 }}>
                  Numerotarea începe de la numărul {standardeNumerotare[0]?.urmatorul_numar || '___'}
                </Alert>
              )}

              {standardeNumerotare.length > 0 && (
                <TableContainer component={Paper} sx={{ mt: 2 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Denumire</TableCell>
                        <TableCell>Ultimul număr</TableCell>
                        <TableCell>Următorul număr</TableCell>
                        <TableCell>Valoare contor</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {standardeNumerotare.map((standard, index) => (
                        <TableRow key={index}>
                          <TableCell>{standard.denumire}</TableCell>
                          <TableCell>{standard.ultimul_numar}</TableCell>
                          <TableCell>{standard.urmatorul_numar}</TableCell>
                          <TableCell>
                            {editingIndex === index ? (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <TextField
                                  size="small"
                                  type="number"
                                  value={editValue}
                                  onChange={(e) => setEditValue(e.target.value)}
                                  onKeyPress={(e) => e.key === 'Enter' && handleSaveContor()}
                                  style={{ width: '80px' }}
                                />
                                <IconButton size="small" onClick={handleSaveContor}>
                                  <CheckIcon fontSize="small" />
                                </IconButton>
                                <IconButton size="small" onClick={handleCancelEdit}>
                                  <CloseIcon fontSize="small" />
                                </IconButton>
                              </div>
                            ) : (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                {standard.valoare_contor}
                                <Tooltip title="Modificare contor">
                                  <IconButton 
                                    onClick={() => handleEditContor(index, standard.valoare_contor)}
                                    size="small"
                                    style={{ padding: '2px' }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </div>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}

              {!numerotareAutomata && (
                <Alert severity="warning" sx={{ mt: 2 }}>
                  Numerotarea automată este dezactivată. Numărul intern al dosarului nu se va numerota automat și va trebui completat manual la crearea dosarului.
                </Alert>
              )}

            </Box>
          </TabPanel>
        )}
            
      </Box>
 
    </>
    
        
  );
};
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <>
    <div
    
    role="tabpanel"
    hidden={value !== index}
    id={`vertical-tabpanel-${index}`}
    aria-labelledby={`vertical-tab-${index}`}
    {...other}
  >
    {value === index && (
      <Box sx={{ p: 3 }}>
        {children}
      </Box>
    )}
  </div>

 </>
  );
 
}
export default DateCont;
